// extracted by mini-css-extract-plugin
export default {"root":"CourseWareViewer_root__NmStW","center":"CourseWareViewer_center__Sosm4"};